import { connect } from 'react-redux';
import React from 'react';
import { Common } from 'ws-scripts/modules/common';
import VehicleTitle from '../components/VehicleTitle';
import VehicleTitleSidebar from '../components/VehicleTitleSidebar';
import propDefs from '../proptypes';

const isBrowser = typeof document === 'object';
class WidgetContainer extends React.Component {
	render() {
		let rootComponent;

		if (this.props.vehicle) {
			const isDesktop = this.props.deviceType === 'DESKTOP';
			const vehicleTitleSidebar =
				isBrowser && isDesktop ? (
					<Common
						render={({ prefs }) => {
							return (
								<VehicleTitleSidebar
									vehicle={this.props.vehicle}
									prefs={prefs}
								/>
							);
						}}
					/>
				) : null;

			rootComponent = (
				<Common
					render={({ prefs }) => {
						return (
							<React.Fragment>
								<VehicleTitle
									vehicle={this.props.vehicle}
									vehicleViews={this.props.vehicleViews}
									prefs={prefs}
								/>
								{vehicleTitleSidebar}
							</React.Fragment>
						);
					}}
				/>
			);
		}
		return rootComponent;
	}
}

WidgetContainer.propTypes = {
	vehicle: propDefs.settings.vehicle,
	deviceType: propDefs.settings.deviceType,
	vehicleViews: propDefs.settings.vehicleViews
};

WidgetContainer.defaultProps = {
	vehicle: propDefs.defaults.vehicle,
	deviceType: propDefs.defaults.deviceType,
	vehicleViews: propDefs.defaults.vehicleViews
};

const mapStateToProps = state => {
	return {
		vehicle: state.vehicle,
		deviceType: state.requestData.deviceType,
		vehicleViews: state.vehicleViews
	};
};

const mapDispatchToProps = _dispatch => ({});

const Widget = connect(mapStateToProps, mapDispatchToProps)(WidgetContainer);

export default Widget;
